import React, { useEffect, useState } from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { socialProofPurchases } from '../data/kit';
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (isDismissed) return;
    const timer = setTimeout(() => setIsVisible(true), 5000);
    return () => clearTimeout(timer);
  }, [isDismissed]);
  useEffect(() => {
    if (!isVisible || isDismissed) return;
    const rotate = setInterval(() => {
      setIndex(i => (i + 1) % socialProofPurchases.length);
    }, 8000);
    return () => clearInterval(rotate);
  }, [isVisible, isDismissed]);
  const purchase = socialProofPurchases[index];
  return <AnimatePresence data-id="element-124" data-mp="3f28fb934xix7">
      {isVisible && !isDismissed && <motion.aside aria-label="Compra reciente" initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.98
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-6 left-6 z-50 bg-white rounded-2xl shadow-xl border border-brand-creamDark p-4 pr-10 max-w-sm flex items-start gap-4" data-id="element-125" data-mp="3k364i5mkbd87">
          <button type="button" onClick={() => setIsDismissed(true)} aria-label="Cerrar aviso" className="absolute top-3 right-3 text-brand-gray transition-colors duration-150 ease-smooth hover:text-brand-text focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-green rounded" data-id="element-126" data-mp="hb1ub5zbrn5f">
            <XIcon className="w-4 h-4" aria-hidden="true" data-id="element-127" data-mp="102ma17ed011f" />
          </button>

          <span className="w-10 h-10 rounded-full bg-brand-greenSoft flex items-center justify-center shrink-0" data-id="element-128" data-mp="1f0en7swfodcg">
            <CheckIcon className="w-5 h-5 text-brand-green" aria-hidden="true" data-id="element-129" data-mp="1a1k7x0xod6x3" />
          </span>

          <div aria-live="polite" data-id="element-130" data-mp="1h5tdpnmy77gm">
            <p className="font-bold text-brand-text text-sm mb-0.5" data-id="element-131" data-mp="1h2np09i8e7lf">
              {purchase.name} &middot; {purchase.city}
            </p>
            <p className="text-brand-green font-bold text-xs mb-1" data-id="element-132" data-mp="1r2ekadem8qmk">
              Se llevó el Kit Yoga Lista
            </p>
            <p className="text-brand-gray text-[10px] flex items-center gap-1" data-id="element-133" data-mp="1vu6bmq5lj0dr">
              <span className="w-1.5 h-1.5 rounded-full bg-brand-green inline-block" data-id="element-134" data-mp="20rg0a3l5v80j" />
              Compra verificada &middot; hace {purchase.minutes} min
            </p>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}